import AxiosConfig from '@/config/axios-config'

export const UsuarioAPI = {

  login (username, password) {
    return AxiosConfig.jalekoAPI().post('/login',
      {
        email: username,
        password: password
      }
    ).then(response => response.data)
  },

  obterUsuario () {
    return AxiosConfig.jalekoAPI().get('user').then(response => response.data)
  },

  alterarSenha (idUsuario, senhaNova) {
    return AxiosConfig.jalekoAPI().post(`admin/conta/usuario/${idUsuario}/senha`, { senhaNova: senhaNova }).then(response => response.data)
  },

  redefinirSenha (idUsuario) {
    return AxiosConfig.jalekoAPI().post(`admin/conta/usuario/${idUsuario}/redefinir-senha`).then(response => response.data)
  },

  gerarAcesso (idUsuario) {
    return AxiosConfig.jalekoAPI().post(`admin/usuario/${idUsuario}/gerar-token-acesso`).then(response => response.data)
  },

  listar (pagina, usuario) {
    let config = { params: { page: pagina } }
    if (usuario) {
      config.params.usuario = usuario
    }
    return AxiosConfig.secureJalekoAPI().get('/admin/conta/usuarios', config).then(response => response.data)
  },

  obterPorId (idUsuario) {
    return AxiosConfig.secureJalekoAPI().get(`admin/conta/usuario/${idUsuario}`).then(response => response.data)
  },

  obterPorEmail (email) {
    return AxiosConfig.secureJalekoAPI().get('admin/conta/usuario/email', { params: { email: email } }).then(response => response.data)
  },

  bloquear (idUsuario) {
    return AxiosConfig.secureJalekoAPI().post(`/admin/conta/usuario/${idUsuario}/bloquear`).then(response => response.data)
  },

  desbloquear (idUsuario) {
    return AxiosConfig.secureJalekoAPI().post(`/admin/conta/usuario/${idUsuario}/desbloquear`).then(response => response.data)
  },

  remover (idUsuario) {
    return AxiosConfig.secureJalekoAPI().delete(`/admin/conta/usuario/${idUsuario}/remover`).then(response => response.data)
  },

  salvar (usuario) {
    return AxiosConfig.secureJalekoAPI().post('/admin/conta/usuario', usuario).then(response => response.data)
  },

  editar (usuario) {
    return AxiosConfig.secureJalekoAPI().post(`/admin/conta/usuario/${usuario.id}/editar`, usuario).then(response => response.data)
  },

  trocarEmail ({ userId, email }) {
    return AxiosConfig.secureJalekoAPI().put(`/admin/usuario/troca-email`, { user_id: userId, email }).then(response => response.data)
  },

  importarUsuarios (arquivo) {
    let formData = new FormData()
    formData.append('file', arquivo)

    return AxiosConfig.secureJalekoAPI().post('/admin/conta/usuarios/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(response => response.data)
  },

  obterStatusImportacaoUsuarios () {
    return AxiosConfig.secureJalekoAPI().get('/admin/conta/usuarios/upload/status').then(response => response.data)
  },

  reenviarEmailPrimeiroAcesso () {
    return AxiosConfig.secureJalekoAPI().post('/admin/conta/usuarios/reenviar-email-primeiro-acesso').then(response => response.data)
  },

  reenviarEmailPrimeiroAcessoUsuario (usuario) {
    return AxiosConfig.secureJalekoAPI().post(`/admin/conta/usuarios/${usuario.id}/reenviar-email-primeiro-acesso`).then(response => response.data)
  },

  excluirUsuario (usuarioId) {
    return AxiosConfig.secureJalekoAPI().put(`/admin/usuario/${usuarioId}/remover-email`).then(response => response.data)
  },

  validarEmail (usuarioId) {
    return AxiosConfig.secureJalekoAPI().put(`/admin/usuario/${usuarioId}/validar-email`).then(response => response.data)
  },

  definirSenha (usuarioId) {
    return AxiosConfig.secureJalekoAPI().put(`/admin/usuario/${usuarioId}/definir-senha-padrao`).then(response => response.data)
  },

  loginPagamento (username, password) {
    return AxiosConfig.jalekoAPIPagamentos().post('/oauth/token',
      {
        username: username,
        password: password,
        grant_type: process.env.VUE_APP_GRANT_TYPE,
        client_id: process.env.VUE_APP_CLIENT_ID,
        client_secret: process.env.VUE_APP_CLIENT_SECRET
      }
    ).then(response => response.data)
  },

  buscaAlunoMundipagg (email) {
    return AxiosConfig.secureJalekoAPIPagamentos().get('/api/alunos', {
      params: { email: email }
    }).then(response => response.data)
  }

}

export default UsuarioAPI
